import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantFormValue, Tenant, TenantExtras } from '../types/tenant.types';
import { DetailResponse } from '@synegen/utility';

@Injectable({ providedIn: 'root' })
export class TenantApiService {
  private http = inject(HttpClient);
  private base = 'tenant';

  getTenant(
    id: number,
    include: string[] = []
  ): Observable<DetailResponse<Tenant, TenantExtras>> {
    let params = new HttpParams();
    for (const name of include) {
      params = params.append('include', name); // ?include=domain&include=roles
    }
    return this.http.get<DetailResponse<Tenant, TenantExtras>>(`${this.base}/${id}`, {
      params
    });
  }

  createTenant(value: TenantFormValue): Observable<DetailResponse<Tenant>> {
    return this.http.post<DetailResponse<Tenant>>(this.base, value);
  }

  updateTenant(id: number, value: TenantFormValue): Observable<DetailResponse<Tenant>> {
    return this.http.patch<DetailResponse<Tenant>>(`${this.base}/${id}`, value);
  }
}
